import { render, staticRenderFns } from "./OfficialNotices.vue?vue&type=template&id=d6ddcdc4&"
import script from "./OfficialNotices.vue?vue&type=script&lang=js&"
export * from "./OfficialNotices.vue?vue&type=script&lang=js&"
import style0 from "./OfficialNotices.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports